import { useCallback } from 'react'
import { Box, Flex } from '@pancakeswap/uikit'
import { styled } from 'styled-components'
import { useSwiper } from 'swiper/react'
import HarvestCard from './HarvestCard'
import UserDetail from './UserDetail'

const StyledCard = styled(Box)`
  border-top: 1px ${({ theme }) => theme.colors.primary} solid;
  border-bottom: 1px ${({ theme }) => theme.colors.primary} solid;
  border-left: 1px ${({ theme }) => theme.colors.primary} solid;
  border-right: 1px ${({ theme }) => theme.colors.primary} solid;
  border-radius: ${({ theme }) => `0 0 ${theme.radii.card} ${theme.radii.card}`};
  background: ${({ theme }) =>
    theme.isDark
      ? 'linear-gradient(360deg, rgba(49, 61, 92, 0.9) 0%, rgba(61, 42, 84, 0.9) 100%)'
      : 'linear-gradient(180deg, rgba(202, 194, 236, 0.9) 0%,  rgba(204, 220, 239, 0.9) 51.04%, rgba(206, 236, 243, 0.9) 100%)'};
`

const UserBanner = () => {
  const swiper = useSwiper()

  const handleHarvestStart = useCallback(() => {
    swiper?.autoplay?.stop()
  }, [swiper])

  const handleHarvestEnd = useCallback(() => {
    swiper?.autoplay?.start()
  }, [swiper])

  return (
    <StyledCard p={['16px', null, null, '40px']}>
      <Flex alignItems="center" justifyContent="center" flexDirection={['column', null, null, 'row']}>
        <Flex flex="1" mr={[null, null, null, '32px']}>
          <UserDetail />
        </Flex>
        <Flex flex="1" width={['100%', null, 'auto']}>
          <HarvestCard onHarvestStart={handleHarvestStart} onHarvestEnd={handleHarvestEnd} />
        </Flex>
      </Flex>
    </StyledCard>
  )
}

export default UserBanner
